module.exports = __webpack_public_path__ + "7fb000790557a981430eefe8c018070a.jpg";